import { render, staticRenderFns } from "./TeacherTicketPage.vue?vue&type=template&id=c1b49180&scoped=true&"
import script from "./TeacherTicketPage.vue?vue&type=script&lang=js&"
export * from "./TeacherTicketPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b49180",
  null
  
)

export default component.exports